import $ from 'jquery';
import { dependency } from '../../utils/request';
import { frame } from '../../utils/drawing';
import { directiveSettings } from '../../utils/parse';
import { uniqueId } from '../../utils/data';

/**
 * The CDN directory of the PhotoSwipe library.
 *
 * @see http://photoswipe.com
 * @type {string}
 */
const photoswipeDir = 'https://cdnjs.cloudflare.com/ajax/libs/photoswipe/4.1.2/';

/**
 * The reusable template for PhotoSwipe.
 *
 * @see http://photoswipe.com/documentation/getting-started.html
 */
const template = `
    <div id="lightbox" class="pswp lightbox" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="pswp__bg"></div>
        <div class="pswp__scroll-wrap">
            <div class="pswp__container">
                <div class="pswp__item lightbox_item"></div>
                <div class="pswp__item lightbox_item"></div>
                <div class="pswp__item lightbox_item"></div>
            </div>
            <div class="pswp__ui pswp__ui--hidden">
                <div class="pswp__top-bar">
                    <div class="pswp__counter"></div>
                    <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
                    <button class="pswp__button pswp__button--share" title="Share"></button>
                    <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
                    <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
                    <div class="pswp__preloader">
                        <div class="pswp__preloader__icn">
                          <div class="pswp__preloader__cut">
                            <div class="pswp__preloader__donut"></div>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                    <div class="pswp__share-tooltip"></div>
                </div>
                <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>
                <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>
                <div class="pswp__caption">
                    <div class="pswp__caption__center"></div>
                </div>
            </div>
        </div>
    </div>
`;

/**
 *
 * @param element
 * @returns {{}}
 */
function getConfigFromElement(element) {
    // TODO
    return {};
}

let initialised = false;
let pswpElement = null;

/**
 * Initializes a PhotoSwipe gallery.
 *
 * @see http://idangero.us/swiper
 * @param context
 */
export default function lightboxDirective(context=document.body) {
    const $context = $(context);
    const $lightboxes = $context.find('[sw-lightbox]');

    if ($lightboxes.length > 0) {

        if (!initialised) {
            initialised = true;

            $('head').append(`
                <link rel="stylesheet" href="${photoswipeDir}photoswipe.min.css">
                <link rel="stylesheet" href="${photoswipeDir}default-skin/default-skin.min.css">
            `);

            $('body').append(template);

            pswpElement = $('#lightbox')[0];
        }

        dependency(photoswipeDir + 'photoswipe.min.js')
        dependency(photoswipeDir + 'photoswipe-ui-default.min.js', () => window.PhotoSwipe && window.PhotoSwipeUI_Default)
            .then(function() {
                const groups = {};

                $lightboxes.each(function() {
                    const $element = $(this);
                    const json = $element.attr('sw-lightbox');
                    const settings = directiveSettings(json, {
                        group: null,
                        thumbnailUrl: '',
                        html: '',
                        url: '',
                        width: 1280,
                        height: 720,
                        title: null,
                    }, 'url');

                    settings.group = settings.group || uniqueId();

                    if (!(settings.group in groups)) {
                        groups[settings.group] = {
                            elements: [],
                            items: [],
                        };
                    }

                    const group = groups[settings.group];
                    const item = {
                        msrc: settings.thumbnailUrl,
                        w: settings.width|0,
                        h: settings.height|0,
                        title: settings.title,
                    };

                    if (settings.html) {
                        item.html = settings.html;
                    } else {
                        item.src = settings.url;
                    }

                    group.elements.push(this);
                    group.items.push(item);

                    $element.on('click', function(e) {
                        e.preventDefault();

                        const options = {
                            history: false,
                            index: group.elements.indexOf(this),
                            getThumbBoundsFn(index) {
                                const $currentElement = $(group.elements[index]);
                                const $thumb = $currentElement.is('[sw-lightbox-thumb]') ?
                                    $currentElement : $currentElement.find('[sw-lightbox-thumb]');
                                const offset = $thumb.offset();
                                const width = $thumb.width();
                                const height = $thumb.height();

                                // If the thumbnail has been letterboxed, this will get the correct width
                                const trueWidth = Math.min(width, height / settings.height * settings.width);

                                return offset ? {
                                    x: offset.left + (width - trueWidth) / 2,
                                    y: offset.top,
                                    w: trueWidth,
                                } : null;
                            },
                        };

                        const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, group.items, options);
                        gallery.init();
                    });
                });
            });
    }
}



// WEBPACK FOOTER //
// ./source/scripts/directives/media/lightbox.js